import React from 'react';
import { Grid } from '@mui/material';
import TeamProfile from '../teamProfile';
import Markdown from '../Markdown';
import Section from '../section';
import SectionTitle from '../sectionTitle';

/**
 * Statement component displays a section with a title, optional team profile, and statement text.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string|string[]} props.text - The statement text to display. Can be a string or an array of strings.
 * @param {string} props.title - The title of the section.
 * @param {Object} [props.profile] - Optional team profile object to display.
 * @param {boolean} [props.centered] - If true, centers the content.
 * @returns {JSX.Element} The rendered Statement section.
 */
const Statement = ({ text, title, profile, centered }) => {
  const Text = ({ text }) =>
    Array.isArray(text) === true ? (
      text.map((text, i) => <Markdown key={i}>{text}</Markdown>)
    ) : (
      <Markdown>{text}</Markdown>
    );

  return (
    <Section>
      <SectionTitle title={title} centered={centered} />
      <Grid container>
        {profile ? (
          <>
            <Grid
              textAlign={centered && 'center'}
              size={{
                xs: 12,
                md: 3
              }}>
              <TeamProfile profile={profile} contactOnly />
            </Grid>
            <Grid
              textAlign={centered && 'center'}
              size={{
                xs: 12,
                md: 9
              }}>
              <Text text={text} />
            </Grid>
          </>
        ) : (
          <Grid textAlign={centered && 'center'} size={12}>
            <Text text={text} />
          </Grid>
        )}
      </Grid>
    </Section>
  );
};

export default Statement;
